import { validateStaffCode } from '@/api/staff';
import { useAppDispatch } from '@/stores/hooks';
import { clearStaffRef, setStaffRef } from '@/stores/appSlice';
import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Reads `?ref=` from the URL, validates staff code, and stores in session.
 */
export default function StaffRefCapture() {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const capturedRef = useRef<string | null>(null);

  useEffect(() => {
    const ref = searchParams.get('ref')?.trim();
    if (!ref || capturedRef.current === ref) return;
    capturedRef.current = ref;

    void (async () => {
      const result = await validateStaffCode(ref);
      if (result.ok) {
        dispatch(setStaffRef({ staffCode: result.staffCode, staffName: result.staffName }));
        const next = new URLSearchParams(searchParams);
        next.delete('ref');
        setSearchParams(next, { replace: true });
      } else {
        dispatch(clearStaffRef());
        navigate('/staff-required', { replace: true });
      }
    })();
  }, [dispatch, navigate, searchParams, setSearchParams]);

  return null;
}
